import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Table, Header } from 'semantic-ui-react';
import numeral from 'numeral';

const PaymentInformationHeader = ({ policies, sources, includeRemaining, hidePaymentOption }) => {
	const totalDue = useMemo(() => policies.reduce((acc, p) => acc + p.amount, 0), [policies]);
	const allocated = useMemo(() => sources.reduce((acc, s) => acc + Object.values((s || {}).amounts || {}).reduce((acc2, v) => acc2 + v, 0), 0), [sources]);
	const remaining = useMemo(() => totalDue - allocated, [allocated, totalDue]);

	const hasAccountBillPolicy = useMemo(() => policies.some((p) => p.isPartOfAccountBill), [policies]);
	
	return (
		<React.Fragment>
			<Header>Policy Breakdown</Header>
			<Table>
				<Table.Header>
					<Table.Row>
						{hasAccountBillPolicy && <Table.HeaderCell>Account Number(s)</Table.HeaderCell>}
						<Table.HeaderCell>Policy Number(s)</Table.HeaderCell>
						{!hidePaymentOption && <Table.HeaderCell>Payment Option</Table.HeaderCell>}
						<Table.HeaderCell textAlign='right'>Due</Table.HeaderCell>
						{includeRemaining && (
							<React.Fragment>
								<Table.HeaderCell textAlign='right'>Allocated</Table.HeaderCell>
								<Table.HeaderCell textAlign='right'>Remaining</Table.HeaderCell>
							</React.Fragment>
						)}
					</Table.Row>
				</Table.Header>
				<Table.Body>
					{policies.map((p, i) => {
						const allocatedForPolicy = includeRemaining ? sources.reduce((acc, s) => acc + (s.amounts[p.displayName] || 0), 0) : 0;
						const remainingForPolicy = includeRemaining ? p.amount - allocatedForPolicy : 0;
						
						return (
							<Table.Row key={i}>
								{hasAccountBillPolicy && <Table.Cell>{p.isPartOfAccountBill && p.isPrimaryAccountPolicy ? p.displayName : ''}</Table.Cell>}
								<Table.Cell>
									{p.isPartOfAccountBill && p.isPrimaryAccountPolicy ? p.policyNumber : p.displayName}
									{p.accountPolicies ? p.accountPolicies.map((pnum, key) => <div key={key}>{pnum}</div>) : null}
								</Table.Cell>
								{!hidePaymentOption && <Table.Cell>{p.paymentOption}</Table.Cell>}
								<Table.Cell textAlign='right'>{numeral(p.amount).format('$ 0,0.00')}</Table.Cell>
								{includeRemaining && (
									<React.Fragment>
										<Table.Cell textAlign='right'>{numeral(allocatedForPolicy).format('$ 0,0.00')}</Table.Cell>
										<Table.Cell textAlign='right'>{numeral(remainingForPolicy).format('$ 0,0.00')}</Table.Cell>
									</React.Fragment>
								)}
							</Table.Row>
						);
					})}
				</Table.Body>
				<Table.Footer>
					<Table.Row>
						{hasAccountBillPolicy && <Table.HeaderCell />}
						{!hidePaymentOption && <Table.HeaderCell />}
						<Table.HeaderCell textAlign='right'>Total</Table.HeaderCell>
						<Table.HeaderCell textAlign='right'>{numeral(totalDue).format('$ 0,0.00')}</Table.HeaderCell>
						{includeRemaining && (
							<React.Fragment>
								<Table.HeaderCell textAlign='right'>{numeral(allocated).format('$ 0,0.00')}</Table.HeaderCell>
								<Table.HeaderCell textAlign='right'>{numeral(remaining).format('$ 0,0.00')}</Table.HeaderCell>
							</React.Fragment>
						)}
					</Table.Row>
				</Table.Footer>
			</Table>
		</React.Fragment>
	);
};

PaymentInformationHeader.propTypes = {
	policies: PropTypes.array.isRequired,
	remainingAmount: PropTypes.number,
};

export default PaymentInformationHeader;
